import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import agent from "../../agent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Submits = inject("commonStore")(
  observer((props) => {
    const history = useHistory();
    // console.log("레벨:", localStorage.getItem("level"));
    // console.log(props.columnId);
    // localStorage.setItem('level', '7'); // 검수자는 레벨 7, 테스트용 코드

    /** 관리자(7)인 경우, 칼럼 진행 상태를 변경할 수 있도록 함 */
    const stpesHandler = (step) => {
      //   console.log("단계변경", step);

      // 칼럼 아이디 넣어줘야 함
      agent.Wordpress.state_update_py(props.columnId, step)
        .then((res) => {
          alert("단계 변경 완료!");
          history.push("/main");
        })
        .catch((err) => {
          if (err.response.statusCode === 500) {
            alert("[admin-steps] 서버 오류로 실패했습니다. 개발팀에 문의해주세요.");
            return;
          }
        });
    };

    if (props.status === 1 && localStorage.getItem("level") !== "7") {
      // 작성자면서 임시저장
      return (
        <Box>
          {localStorage.getItem("level") === "7" ? (
            <>
              <span className="force" onClick={() => props.openModal(2)}>
                강제 업로드
              </span>
              <span className="change-steps" onClick={() => stpesHandler(1)}>
                임시저장
              </span>
              <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                검수전
              </span>
              <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                반려
              </span>
              <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                검수완료
              </span>
              <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                업로드완료
              </span>
            </>
          ) : (
            <></>
          )}
          <span className="save" onClick={() => props.submitHandler(1)}>
            임시저장
          </span>
          <span onClick={() => props.submitHandler(2)}>제출</span>
        </Box>
      );
    } else if (props.status === 1 && localStorage.getItem("level") === "7") {
      // 검수자면서 임시저장
      if (props.writerId === parseInt(localStorage.getItem("writer_id"))) {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="save" onClick={() => props.submitHandler(1)}>
              임시저장
            </span>
            <span className="common" onClick={() => props.submitHandler(2)}>
              제출
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      } else {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="common" style={{ pointerEvents: "none" }}>
              <p>아직 제출하지 않은 상태입니다!</p>
            </span>
            {parseInt(localStorage.getItem("writer_id")) === 224 && (
              <span className="save" onClick={() => props.submitHandler(1)}>
                임시저장
              </span>
            )}
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
            {parseInt(localStorage.getItem("writer_id")) === 224 && <span onClick={() => props.submitHandler(2)}>제출</span>}
          </Box>
        );
      }
    } else if (props.status === 2 && localStorage.getItem("level") !== "7") {
      // 작성자면서 검수 전(제출)
      return (
        <Box>
          {localStorage.getItem("level") === "7" ? (
            <>
              <span className="force" onClick={() => props.openModal(2)}>
                강제 업로드
              </span>
              <span className="change-steps" onClick={() => stpesHandler(1)}>
                임시저장
              </span>
              <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                검수전
              </span>
              <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                반려
              </span>
              <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                검수완료
              </span>
              <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                업로드완료
              </span>
            </>
          ) : (
            <></>
          )}
          <span className="mod" onClick={() => props.submitHandler(6)}>
            수정
          </span>
        </Box>
      );
    } else if (props.status === 2 && localStorage.getItem("level") === "7") {
      // 검수자면서 검수 전(제출)
      if (props.writerId === parseInt(localStorage.getItem("writer_id"))) {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="mod" onClick={() => props.submitHandler(6)}>
              수정
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      } else {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="del" onClick={() => props.openModal(3)}>
              반려
            </span>
            <span className="complete" onClick={() => props.openModal(4)} style={{ background: "#3B86FF" }}>
              검수완료
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
            {parseInt(localStorage.getItem("writer_id")) === 224 && (
              <span className="mod" onClick={() => props.submitHandler(6)}>
                수정
              </span>
            )}
          </Box>
        );
      }
    } else if (props.status === 3 && localStorage.getItem("level") !== "7") {
      // 작성자면서 반려
      return (
        <Box>
          {localStorage.getItem("level") === "7" ? (
            <>
              <span className="force" onClick={() => props.openModal(2)}>
                강제 업로드
              </span>
              <span className="change-steps" onClick={() => stpesHandler(1)}>
                임시저장
              </span>
              <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                검수전
              </span>
              <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                반려
              </span>
              <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                검수완료
              </span>
              <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                업로드완료
              </span>
            </>
          ) : (
            <></>
          )}
          <span className="save" onClick={() => props.submitHandler(1)}>
            임시저장
          </span>
          <span onClick={() => props.submitHandler(2)}>제출</span>
        </Box>
      );
    } else if (props.status === 3 && localStorage.getItem("level") === "7") {
      // 검수자면서 반려
      if (props.writerId === parseInt(localStorage.getItem("writer_id"))) {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="save" onClick={() => props.submitHandler(1)}>
              임시저장
            </span>
            <span className="common" onClick={() => props.submitHandler(2)}>
              제출
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      } else {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="common" style={{ pointerEvents: "none" }}>
              <p>아직 제출하지 않은 상태입니다!</p>
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      }
    } else if (props.status === 4 && localStorage.getItem("level") !== "7") {
      // 작성자면서 검수완료
      return (
        <Box>
          {localStorage.getItem("level") === "7" ? (
            <>
              <span className="force" onClick={() => props.openModal(2)}>
                강제 업로드
              </span>
              <span className="change-steps" onClick={() => stpesHandler(1)}>
                임시저장
              </span>
              <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                검수전
              </span>
              <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                반려
              </span>
              <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                검수완료
              </span>
              <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                업로드완료
              </span>
            </>
          ) : (
            <></>
          )}
          <span className="mod" onClick={() => props.submitHandler(6)}>
            수정
          </span>
          <span className="upload" onClick={() => props.openModal(2)}>
            업로드
          </span>
        </Box>
      );
    } else if (props.status === 4 && localStorage.getItem("level") === "7") {
      // 검수자면서 검수완료
      if (props.writerId === parseInt(localStorage.getItem("writer_id"))) {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="mod" onClick={() => props.submitHandler(6)}>
              수정
            </span>
            <span className="upload" onClick={() => props.openModal(2)}>
              업로드
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      } else {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="common" style={{ pointerEvents: "none" }}>
              <p>아직 업로드하지 않은 상태입니다!</p>
            </span>
            <span className="common" onClick={() => props.openModal(2)}>
              업로드
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      }
    } else if (props.status === 5 && localStorage.getItem("level") !== "7") {
      // 작성자면서 업로드
      return (
        <Box>
          {localStorage.getItem("level") === "7" ? (
            <>
              <span className="force" onClick={() => props.openModal(2)}>
                강제 업로드
              </span>
              <span className="change-steps" onClick={() => stpesHandler(1)}>
                임시저장
              </span>
              <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                검수전
              </span>
              <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                반려
              </span>
              <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                검수완료
              </span>
              <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                업로드완료
              </span>
            </>
          ) : (
            <></>
          )}
          <span className="mod" onClick={() => props.submitHandler(7)}>
            수정
          </span>
        </Box>
      );
    } else if (props.status === 5 && localStorage.getItem("level") === "7") {
      // 검수자면서 업로드
      if (props.writerId === parseInt(localStorage.getItem("writer_id"))) {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="mod" onClick={() => props.submitHandler(7)}>
              수정
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      } else {
        return (
          <Box>
            {localStorage.getItem("level") === "7" ? (
              <>
                <span className="force" onClick={() => props.openModal(2)}>
                  강제 업로드
                </span>
                <span className="change-steps" onClick={() => stpesHandler(1)}>
                  임시저장
                </span>
                <span className="change-steps" onClick={() => stpesHandler(2)} value="2">
                  검수전
                </span>
                <span className="change-steps" onClick={() => stpesHandler(3)} value="3">
                  반려
                </span>
                <span className="change-steps" onClick={() => stpesHandler(4)} value="4">
                  검수완료
                </span>
                <span className="change-steps" onClick={() => stpesHandler(5)} value="5">
                  업로드완료
                </span>
              </>
            ) : (
              <></>
            )}
            <span className="upload" style={{ pointerEvents: "none" }}>
              <p>업로드한 게시물입니다.</p>
            </span>
            <span className="mod" onClick={() => props.submitHandler(7)}>
              수정
            </span>
            <span className="del" onClick={props.delHandler}>
              삭제
            </span>
          </Box>
        );
      }
    }
  })
);

const Box = styled.div`
  width: 94%;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;

  > span {
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 20px;
    margin-left: 5px;
    cursor: pointer;
    color: white;
  }
  > span:first-child {
    color: white;
    background: #aeaeae;
  }

  > .mod {
    background: #aeaeae !important;
  }

  > .save {
    border: 1px solid #42415c;
    background: white !important;
    color: #42415c !important;
  }

  > .del {
    background: #b5988e !important;
  }

  > .force {
    background: #ed6258 !important;
  }

  > .common {
    background: grey;
  }

  .change-steps {
    padding: 10px 10px;
    background-color: #adc0c7 !important;
  }

  > .upload {
    background: #42415c !important;
  }

  > .complete {
    background: #3b86ff !important;
  }

  > span:last-child,
  > span:nth-child(2) {
    background: #42415c;
  }
`;

export default Submits;
